import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * OAuth Callback Handler
 * Google redirects here with ?code=xxx&state=xxx
 * We then redirect to /adsense with the same params
 */
export default function AdSenseCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (error) {
      // Redirect to adsense with error
      navigate(`/adsense?error=${error}`);
    } else if (code) {
      // Redirect to adsense with code and state
      navigate(`/adsense?code=${code}&state=${state || ''}`);
    } else {
      // No code, just go to adsense
      navigate('/adsense');
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-muted-foreground">Connecting to AdSense...</p>
      </div>
    </div>
  );
}
